module.exports = __webpack_public_path__ + "吴梦夏-b53d6df3.png";